import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Check if localStorage is available (not blocked by in-app browsers)
let localStorageAvailable = false;
try {
  localStorage.setItem('__test__', '1');
  localStorage.removeItem('__test__');
  localStorageAvailable = true;
} catch (e) {
  localStorageAvailable = false;
}

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'ceb'],
    debug: false,

    detection: {
      // Only use localStorage if available, otherwise just use navigator
      order: localStorageAvailable ? ['localStorage', 'navigator'] : ['navigator'],
      caches: localStorageAvailable ? ['localStorage'] : [],
    },

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    ns: ['common'],
    defaultNS: 'common',

    // Return the default value instead of the key when translation is missing
    returnEmptyString: false,
    returnNull: false,
  });

export default i18n;
